<template>
  <div>
    <div class="row" v-if="getComentarios">
      <div class="col-md-12">
        <div class="mural mural_recados">
          <div class="content">
            <div class="numero_mensagens">{{ getComentarios.length }} mensagens</div>
            <div class="comentario" v-for="item in getComentarios">
              <div class="avatar">
                {{ getNameComment(item.nome) }}
              </div>
              <span>{{ item.nome }}</span>
              <p>{{ item.mensagem }}</p>
              <div class="resposta" v-if="item.resposta">
                <div class="avatar">A</div>
                <span> Admin </span>
                <p>{{ item.resposta }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br>
    <br>
    <div class="row">
      <div class="col-md-12">
        <div class="peca_musica enviar_recado">
          <form>

            <label>
              Nome:
              <input type="text" v-model="name">
            </label>
            <label>
              Email:
              <input type="text" v-model="email">
            </label>
            <label>
              Estado:
              <select name="estados-brasil" v-model="state">
                <option value="AC">Acre</option>
                <option value="AL">Alagoas</option>
                <option value="AP">Amapá</option>
                <option value="AM">Amazonas</option>
                <option value="BA">Bahia</option>
                <option value="CE">Ceará</option>
                <option value="DF">Distrito Federal</option>
                <option value="ES">Espírito Santo</option>
                <option value="GO">Goiás</option>
                <option value="MA">Maranhão</option>
                <option value="MT">Mato Grosso</option>
                <option value="MS">Mato Grosso do Sul</option>
                <option value="MG">Minas Gerais</option>
                <option value="PA">Pará</option>
                <option value="PB">Paraíba</option>
                <option value="PR">Paraná</option>
                <option value="PE">Pernambuco</option>
                <option value="PI">Piauí</option>
                <option value="RJ">Rio de Janeiro</option>
                <option value="RN">Rio Grande do Norte</option>
                <option value="RS">Rio Grande do Sul</option>
                <option value="RO">Rondônia</option>
                <option value="RR">Roraima</option>
                <option value="SC">Santa Catarina</option>
                <option value="SP">São Paulo</option>
                <option value="SE">Sergipe</option>
                <option value="TO">Tocantins</option>
              </select>
            </label>
            <label>
              Cidade:
              <input type="text" v-model="city">
            </label>
            <label class="mensagem">
              Mensagem:
              <textarea v-model="message"></textarea>
            </label>

            <vue-recaptcha ref="recaptcha" @verify="onVerify" @expired="onExpired" :sitekey="sitekey" class="captcha">
            </vue-recaptcha>

            <button class="btn_enviar" type="button" @click="callback()"> Enviar</button>

          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {get, post} from '../helpers/api';
  import VueRecaptcha from 'vue-recaptcha';

  export default {
    components: {
      VueRecaptcha
    },
    data() {
      return {
        title: 'Comentários',
        showContent: false,
        items: [],
        name: '',
        email: '',
        city: '',
        state: '',
        message: '',
        errorMessage: '',
        successMessage: '',
        sitekey: window.config.RECAPTCHA_KEY,
        captcha: false
      }
    },
    name: "Comentarios",
    props: ['comments', 'tipo', 'referencia'],
    methods: {
      onSubmit: function () {
        this.$refs.recaptcha.execute();
      },
      onVerify: function (response) {
        this.captcha = response;
      },
      onExpired: function () {
      },
      resetRecaptcha() {
        this.$refs.recaptcha.reset() // Direct call reset method
      },
      getNameComment(nome) {
        return nome.charAt(0);
      },
      clearForm() {
        this.name = '';
        this.email = '';
        this.city = '';
        this.state = '';
        this.message = '';
      },
      callback(token) {
        // google recaptcha token , then you can pass to backend with your form data .

        if (!this.name) {
          alert('O campo nome é obrigatório.');
          return false;
        }
        if (!this.email) {
          alert('O campo email é obrigatório.');
          return false;
        }
        if (!this.message) {
          alert('O campo messagem é obrigatório.');
          return false;
        }
        if (!this.captcha) {
          alert('Favor marcar captcha.');
          return false;
        }
        this.showContent = false;
        let self = this;
        post('comentario', {
          tipo: this.tipo,
          referencia: this.referencia,
          nome: this.name,
          email: this.email,
          cidade: this.city,
          estado: this.state,
          mensagem: this.message
        }).then(function () {
          self.showContent = true;
          swal({
            title: "Comentário enviado com sucesso.",
            icon: "success",
          });
          self.clearForm();
        }).catch(function () {
          self.showContent = true;
          swal({
            title: "Ocorreu um erro ao enviar a mensagem, tente novamente mais tarde.",
            icon: "error",
          });
        });

      },
    },
    computed: {
      getComentarios() {
        return this.comments;
      },
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/Comentarios.vue